import React from 'react';
import '../styles/Slider.css';

const Slider = () => {
  return (
    <div className="slider-container">
      <div className="slider-header">
      </div>
    </div>
  );
};

export default Slider;